export const TEST = "TEST";

export const GET_MARCAS = "GET_MARCAS";
export const GET_MARCAS_SUCCESS = "GET_MARCAS_SUCCESS";
export const GET_MARCAS_FAILED = "GET_MARCAS_FAILED";

export const GET_BRAND_BY_MODEL = "GET_BRAND_BY_MODEL";
export const GET_BRAND_BY_MODEL_SUCCESS = "GET_BRAND_BY_MODEL_SUCCESS";
export const GET_BRAND_BY_MODEL_FAILED = "GET_BRAND_BY_MODEL_FAILED";

export const GET_MODELOS = "GET_MODELOS";
export const GET_MODELOS_SUCCESS = "GET_MODELOS_SUCCESS";
export const GET_MODELOS_FAILED = "GET_MODELOS_FAILED";

export const GET_HOMOLOGATION = "GET_HOMOLOGATION";
export const GET_HOMOLOGATION_SUCCESS = "GET_HOMOLOGATION_SUCCESS";
export const GET_HOMOLOGATION_FAILED = "GET_HOMOLOGATION_FAILED";

export const GET_HOMOLOGATED_CARS = "GET_HOMOLOGATED_CARS";
export const GET_HOMOLOGATED_CARS_SUCCESS = "GET_HOMOLOGATED_CARS_SUCCESS";
export const GET_HOMOLOGATED_CARS_FAILED = "GET_HOMOLOGATED_CARS_FAILED";

export const GET_HOMOLOGATED = "GET_HOMOLOGATED";
export const GET_HOMOLOGATED_SUCCESS = "GET_HOMOLOGATED_SUCCESS";
export const GET_HOMOLOGATED_FAILED = "GET_HOMOLOGATED_FAILED";

export const GET_GASTOS = "GET_GASTOS";
export const GET_GASTOS_SUCCESS = "GET_GASTOS_SUCCESS";
export const GET_GASTOS_FAILED = "GET_GASTOS_FAILED";

export const GET_PLAZOS = "GET_PLAZOS";
export const GET_PLAZOS_SUCCESS = "GET_PLAZOS_SUCCESS";
export const GET_PLAZOS_FAILED = "GET_PLAZOS_FAILED";

export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILED = "GET_PRODUCTS_FAILED";

export const POST_CALCULATE_FEE = "POST_CALCULATE_FEE";
export const POST_CALCULATE_FEE_SUCCESS = "POST_CALCULATE_FEE_SUCCESS";
export const POST_CALCULATE_FEE_FAILED = "POST_CALCULATE_FEE_FAILED";

export const GET_TYPE_PRODUCTS = "GET_TYPE_PRODUCTS";
export const GET_TYPE_PRODUCTS_SUCCESS = "GET_TYPE_PRODUCTS_SUCCESS";
export const GET_TYPE_PRODUCTS_FAILED = "GET_TYPE_PRODUCTS_FAILED";

export const GET_TASA_VFMG = "GET_TASA_VFMG";
export const GET_TASA_VFMG_SUCCESS = "GET_TASA_VFMG_SUCCESS";
export const GET_TASA_VFMG_FAILED = "GET_TASA_VFMG_FAILED";

export const GET_REGISTRATION = "GET_REGISTRATION";
export const GET_REGISTRATION_SUCCESS = "GET_REGISTRATION_SUCCESS";
export const GET_REGISTRATION_FAILED = "GET_REGISTRATION_FAILED";

export const GET_CES_SPIDER = "GET_CES_SPIDER";
export const GET_CES_SPIDER_SUCCESS = "GET_CES_SPIDER_SUCCESS";
export const GET_CES_SPIDER_FAILED = "GET_CES_SPIDER_FAILED";

export const GET_MONTHS = "GET_MONTHS";
export const GET_MONTHS_SUCCESS = "GET_MONTHS_SUCCESS";
export const GET_MONTHS_FAILED = "GET_MONTHS_FAILED";

export const POST_INYECTION_TRINIDAD = "POST_INYECTION_TRINIDAD";
export const POST_INYECTION_TRINIDAD_SUCCESS =
  "POST_INYECTION_TRINIDAD_SUCCESS";
export const POST_INYECTION_TRINIDAD_FAILED = "POST_INYECTION_TRINIDAD_FAILED";